import { QuoteElement } from "../../lib/quote-element.js";
import { SelectedState } from "../../lib/selected-state.js";
import { property, customElement } from "lit/decorators.js";
import "../../common/legal-disclaimer.js";
import "../../common/peril-list.js";
import "../../common/promotional-description.js";
import "../../common/promotional-header.js";
import "../../common/offer-checkbox-button.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let ShippingInsurance = class extends QuoteElement {
  constructor() {
    super("shipping");
    this.selectedState = SelectedState.DECLINED;
  }
  toggleOfferSelection() {
    if (this.selectedState === SelectedState.ACCEPTED) {
      this.decline();
    } else {
      this.accept();
    }
  }
  get courierId() {
    switch (this.courier) {
      case "usps":
        return 1;
      case "fedex":
        return 2;
      case "ups":
        return 3;
      default:
        return 1;
    }
  }
  /**
   * @ignore
   */
  get policyAttributes() {
    return {
      declared_value: this.declaredValue,
      courier_id: this.courierId,
      tracking_number: this.trackingNumber,
      shipment_date: this.shipmentDate
    };
  }
};
ShippingInsurance.styles = [
  QuoteElement.styles
];
__decorateClass([
  property({ type: Number, attribute: "declared-value" })
], ShippingInsurance.prototype, "declaredValue", 2);
__decorateClass([
  property({ attribute: "shipment-date" })
], ShippingInsurance.prototype, "shipmentDate", 2);
__decorateClass([
  property({ attribute: "tracking-number" })
], ShippingInsurance.prototype, "trackingNumber", 2);
__decorateClass([
  property({ attribute: "courier" })
], ShippingInsurance.prototype, "courier", 2);
ShippingInsurance = __decorateClass([
  customElement("shipping-insurance")
], ShippingInsurance);
export {
  ShippingInsurance
};
